<template>
  <div class="RecordingTreeView">
    <ul id="demo" class="RecordingTreeList">
      <RecordingTreeItem v-for="item in treeData"
                         class="item"
                         :recording="item"
      />
    </ul>
  </div>
</template>

<script>
  import RecordingTreeItem from './RecordingTreeItem'

  export default {
    components: { RecordingTreeItem },
    props: { treeData: Array }
  }
</script>
